import { render, staticRenderFns } from "./Cart.vue?vue&type=template&id=f280016a&scoped=true"
import script from "./Cart.vue?vue&type=script&lang=ts"
export * from "./Cart.vue?vue&type=script&lang=ts"
import style0 from "./Cart.vue?vue&type=style&index=0&id=f280016a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f280016a",
  null
  
)

export default component.exports